import { useTranslations as _useTranslations } from '@ds/swymkit/tools'

import { isRunningInTest } from '~/features-shared/libs/utils/vitest'

import type { NLS_Record } from '~/typings/nls/index'

type NlsRecordKeys = keyof NLS_Record

/**
 * Use translations hosted in /assets/nls/**.json. It will return the i18n ref object and a $i18n function.
 * @warn Translation are download from network, so i18n object might be empty !
 * Use the `promise` to await for the download to be done
 * @param filename the nls file name
 * @param path give the DS AMDLoader path, @default 'i18n!DS/SwymVueWeb/assets/nls/'
 */
export function useTranslations<
  T extends NlsRecordKeys,
  U extends NLS_Record[T],
>(filename: T, path = 'i18n!DS/SwymVueWeb/assets/nls/'): {
  i18n: Ref<Partial<U>>
  $i18n: {
    (key: undefined): ''
    <V extends keyof U>(key: V, variables?: Record<string, unknown>): U[V] | typeof key
  }
  promise: Promise<U>
} {
  let modules: Record<string, () => Promise<U>> | undefined

  if (import.meta.env.DEV && !isRunningInTest())
    modules = import.meta.glob<false, '', U>('/assets/nls/**/*_en.json', { import: 'default' })

  const { i18n, $i18n, promise } = _useTranslations<any, any>(filename, path, modules, import.meta.env.DEV)
  return { i18n, $i18n, promise }
}
